import React from 'react'
import { ReactComponent as IndustryDark } from '../../assets/promptIcons/industryDark.svg';
import { ReactComponent as LegalDark } from '../../assets/promptIcons/legalDark.svg';
import { ReactComponent as MoneyboxDark } from '../../assets/promptIcons/moneyboxDark.svg';
import { ReactComponent as UserDark } from '../../assets/promptIcons/userDark.svg';
import { ReactComponent as CheckCircle } from '../../assets/promptIcons/checkCircle.svg';
import { ReactComponent as DangerCircle } from '../../assets/promptIcons/dangerCircle.svg';
import { ReactComponent as Accelerate } from '../../assets/promptIcons/card_recive.svg';
import { ReactComponent as CPU } from '../../assets/promptIcons/CPU.svg';
import { ReactComponent as Refresh } from '../../assets/promptIcons/refresh.svg';
import { ReactComponent as UserCheck } from '../../assets/promptIcons/user_check.svg';
import { ReactComponent as Stopwatch } from '../../assets/promptIcons/stopwatch.svg';
import { ReactComponent as Check } from '../../assets/promptIcons/check.svg';
import { ReactComponent as Moneybox } from '../../assets/promptIcons/moneybox.svg';
import { Button } from '../../components/common';
import PercentageBanner from '../../components/public/GptPrompts/PercentageBanner';
import PromptBanner from '../../components/public/GptPrompts/PromptBanner';
import GptTestimonials from '../../components/public/GptPrompts/GptTestimonials';
import { FrequentAskQuestion } from '../../components/public/GptPrompts/FrequentAskQuestion';
import { useNavigate } from 'react-router-dom';
import InsideSections from '../../components/public/GptPrompts/InsideSections';
import { handlePromptStripePayment } from '../../utils/Helper';

function GptPrompts() {
  const { REACT_APP_GPT_PROMPT_PAYMENT_LINK } = process.env;
  const bannerData = [{
    id: 1,
    icon: Stopwatch,
    headerText: 'Faster Follow-Ups',
    text: 'Ensure timely communication for quicker payment resolutions every time.',
  },
  {
    id: 2,
    icon: Check,
    headerText: 'Clearer Conversations',
    text: 'Communicate with clarity to avoid misunderstandings and delays.',
  },
  {
    id: 3,
    icon: Moneybox,
    headerText: 'Improved Payment Outcomes',
    text: 'Drive successful payments with targeted and effective messaging.',
  }]
  const aboutPrompt = [{
    id: 1,
    header: "Credit & Collections Teams",
    subText1: "Chasing overdue payments without sounding repetitive or unprofessional.",
    subText2: "Ready-made prompts for reminders, follow-ups, and escalations ensure you recover payments faster while maintaining relationships.",
    icon: UserDark
  },
  {
    id: 2,
    header: "Small and Large Businesses (SMEs & Enterprises) ",
    subText1: "Balancing collections with other priorities while managing cash flow.",
    subText2: "Streamline your process with Al-ready templates-save time, improve efficiency, and focus on growing your business.",
    icon: IndustryDark
  },
  {
    id: 3,
    header: "Legal & Advisory Teams",
    subText1: "Navigating escalations and sensitive disputes without missteps.",
    subText2: "Professional, compliant scripts tailored to complex situations help you handle escalations seamlessly.",
    icon: LegalDark
  },
  {
    id: 4,
    header: "Finance Departments",
    subText1: "Managing accounts receivable and ensuring timely payments.",
    subText2: "Clear, effective communication templates reduce delays, re- solve disputes faster, and keep your payment cycles on track.",
    icon: UserDark
  }
  ]
  // const navigate = useNavigate();
  return (
    <div className='w-full h-auto overflow-x-hidden'>
      <div className='bg-prompt-whiteXL-bg object-cover bg-cover relative px-5 md:px-0 w-full h-[calc(100vh+80px)] mb-10'>
        <div className='max-w-[1280px] m-auto px-4 h-full flex flex-col items-center justify-center'>
          <PromptBanner handlePromptStripePayment={() => handlePromptStripePayment(REACT_APP_GPT_PROMPT_PAYMENT_LINK)} />
        </div>
      </div>
      <PercentageBanner bannerData={bannerData} />
      <div className='max-w-[1280px] m-auto my-10 px-4 lg:px-6 py-4'>
        <div className='w-[215px] bg-secondary text-link rounded py-2 text-center'>
          WHY CHOOSE TREVEX
        </div>
        <div className='flex flex-col md:flex-row justify-between items-center'>
          <div className='max-w-[668px] text-left flex flex-col gap-2 py-2'>
            <h1 className='text-f40 font-bold text-primary'>Why Choose TREVEX Prompts?</h1>
            <p className='text-secondarytwo font-f18'>Discover AI-driven prompts designed to streamline your B2B collections, accelerate recoveries, and maintain professionalism in every communication.</p>
          </div>
          <Button onClick={() => handlePromptStripePayment(REACT_APP_GPT_PROMPT_PAYMENT_LINK)} classes="w-full mt-5 md:mt-0 md:w-[322px] h-[96px] bg-primary text-slate rounded-[16px] font-bold flex justify-center items-center text-f30">Get Started for $99</Button>
        </div>
      </div>
      <div className='max-w-[1280px] m-auto flex flex-col gap-5 mt-10 mb-20'>
        <div className='flex flex-col px-3 md:px-0 md:flex-row justify-center gap-5'>
          <div className='w-full md:w-[542px] flex flex-col gap-2 items-start bg-slate p-6 border border-[#F1F1F1] rounded-[12px]'>
            <UserCheck />
            <h4 className='text-left text-f24 text-navActive font-semibold'>Crafted for B2B Collection Experts</h4>
            <p className='text-left text-secondarytwo'>Skip the guesswork. Our AI-optimized prompts enable you to craft compelling messages that resonate, ensuring quicker resolutions and improved cash flow.</p>
          </div>
          <div className='w-full md:w-[542px] flex flex-col gap-2 items-start bg-slate p-6 border border-[#F1F1F1] rounded-[12px]'>
            <Accelerate />
            <h4 className='text-left text-f24 text-navActive font-semibold'>Accelerate Payment Recoveries</h4>
            <p className='text-left text-secondarytwo'>Every prompt is designed with the unique nuances of B2B collections in mind. From initial outreach to escalation, our templates are tested and proven to work.</p>
          </div>
        </div>
        <div className='flex flex-col px-3 md:px-0 md:flex-row justify-center gap-5'>
          <div className='w-full md:w-[542px] flex flex-col gap-2 items-start bg-slate p-6 border border-[#F1F1F1] rounded-[12px]'>
            <Refresh />
            <h4 className='text-left text-f24 text-navActive font-semibold'>Simplify Your Workflow</h4>
            <p className='text-left text-secondarytwo'>No more struggling with what to say or how to say it. Plug-and-play prompts help you save time, maintain professionalism, and achieve better outcomes.</p>
          </div>
          <div className='w-full md:w-[542px] flex flex-col gap-2 items-start bg-slate p-6 border border-[#F1F1F1] rounded-[12px]'>
            <CPU />
            <h4 className='text-left text-f24 text-navActive font-semibold'>Stay Ahead with AI</h4>
            <p className='text-left text-secondarytwo'>Equip yourself with tools powered by cutting-edge AI. Optimize every interaction, whether you're handling overdue invoices, negotiating payment terms, or managing disputes.</p>
          </div>
        </div>
      </div>
      <div className='flex flex-col items-center gap-3 my-10'>
        <div className='w-[169x] bg-secondary text-link rounded px-6 py-2 text-center'>
          Core Features
        </div>
        <h1 className='text-f40 font-bold text-primary'>What’s Inside?</h1>
        <p className='w-full px-3 sm:px-0 sm:w-[716px] text-secondarytwo font-f18'>Explore the tools and features that make TREVEX your ultimate B2B collection companion—versatile, impactful, and tailored to your needs.</p>
      </div>
      <InsideSections />
      <div className='flex justify-center mb-10 p-3 sm:p-0'>
        <Button onClick={() => handlePromptStripePayment(REACT_APP_GPT_PROMPT_PAYMENT_LINK)} classes="w-full sm:w-[452px] h-[96px] bg-primary text-slate rounded-[16px] font-bold flex justify-center items-center text-[23px] sm:text-f30">Get Lifetime Access for $99</Button>
      </div>
      <div className='py-4'>
        <div className='bg-prompt-blueXL-bg object-cover bg-cover mb-10'>
          <div className=' flex flex-col items-center justify-between text-slate px-3 py-5 sm:p-[48px]'>
            <div className='bg-[#97AAB5] text-[#004469] rounded px-6 py-2 text-center mb-6'>
              {"Who Benefits from TREVEX?".toUpperCase()}
            </div>
            <h1 className='text-f40 font-bold'>Who is TREVEX Prompts For?</h1>
            <p className='w-full p-3 sm:p-0 sm:w-[716px] font-f18 mb-12'>If These Challenges Sound Familiar, We're Here to Help.</p>
            {/* <div className='w-full flex justify-between text-f20 font-semibold '>
              <div className='bg-[#41728D] flex flex-col items-center justify-center rounded-[8px] w-[260px] h-[192px] p-6 justify-between'>
                <Credit />
                <p >Credit & Collections Professionals</p>
              </div>
              <div className='bg-[#41728D] flex flex-col items-center justify-center rounded-[8px] w-[260px] h-[192px] p-6 justify-between'>
                <SME />
                <p className='w-[237px]'>SMEs and Enterprises</p>
              </div>
              <div className='bg-[#41728D] flex flex-col items-center justify-center rounded-[8px] w-[260px] h-[192px] p-6 justify-between'>
                <Legal />
                <p>Legal Teams & Consultants</p>
              </div>
              <div className='bg-[#41728D] flex flex-col items-center justify-center rounded-[8px] w-[260px] h-[192px] p-6 justify-between'>
                <Finance />
                <p>Finance Departments</p>
              </div>
            </div> */}
            <div className='flex flex-col gap-4 mb-12'>
              {aboutPrompt.map(about => (
                <div key={about.id} className='max-w-[1200px] w-full p-6 bg-[#01304A] rounded-[12px]'>
                  <div className='flex gap-2 justify-start items-center border-b border-[#2C5369] pb-3 mb-3'>
                    <about.icon />
                    <p className='text-[28px] font-semibold text-white text-left md:text-center'>{about.header}</p>
                  </div>
                  <div className='w-full h-auto md:h-[125px] lg:h-[103px] flex flex-col md:flex-row justify-between overflow-wrap items-center gap-4'>
                    <div className='w-full md:w-[50%] h-full bg-[#09405F] rounded-[8px] py-3 px-4'>
                      <div className='flex gap-2 justify-start items-center pb-2'>
                        <DangerCircle />
                        <p className='font-semibold text-[#E6ECF0] underline decoration-[#FF9700] underline-offset-[6px]'>{"Your Challenge".toUpperCase()}</p>
                      </div>
                      <p className='text-left text-[#A7BECB]'>{about.subText1}</p>
                    </div>
                    <div className='w-full md:w-[50%] h-full bg-[#09405F] rounded-[8px] py-3 px-4'>
                      <div className='flex gap-2 justify-start items-center pb-2'>
                        <CheckCircle />
                        <p className='font-semibold text-[#E6ECF0] underline decoration-[#FF9700] underline-offset-[6px]'>{"How TREVEX Helps".toUpperCase()}</p>
                      </div>
                      <p className='text-left text-[#A7BECB]'>{about.subText2}</p>
                    </div>
                  </div>

                </div>
              ))}
            </div>
            <Button onClick={() => handlePromptStripePayment(REACT_APP_GPT_PROMPT_PAYMENT_LINK)} classes="w-full md:w-[452px] h-[96px] bg-primary text-slate rounded-[16px] font-bold flex justify-center items-center text-[23px] sm:text-f30">Get Lifetime Access for $99</Button>
          </div>
        </div>
      </div>
      <div className='max-w-[1280px] m-auto px-4 lg:px-6 py-4'>
        <div className='bg-prompt-orange-bg object-cover bg-cover mb-10 rounded-[8px]'>
          <div className='h-full sm:h-[350px] flex flex-col items-center justify-between text-slate p-[48px]'>
            <h1 className='text-f40 font-bold'>Ready to Recover Smarter, Not Harder?</h1>
            <p className='w-full sm:w-[716px] font-f18'>Join the thousands of professionals revolutionizing their collections game. Your next success story starts here.</p>
            <Button onClick={() => handlePromptStripePayment(REACT_APP_GPT_PROMPT_PAYMENT_LINK)} classes="w-[308px] mt-4 sm:mt-0 h-[96px] bg-slate text-link rounded-[16px] font-bold flex justify-center items-center text-f30">Get Started Now</Button>
          </div>
        </div>
      </div>
      {/* <GptTestimonials />
      <FrequentAskQuestion /> */}
      {/* <div className='max-w-[1280px] m-auto px-4 lg:px-6 py-4'>
        <div className='bg-prompt-blue-bg object-cover bg-cover mb-10 rounded-[8px]'>
          <div className='h-[350px] flex flex-col items-center justify-between text-slate p-[48px]'>
            <h1 className='text-f40 font-bold'>Boost Your Success Today</h1>
            <p className='w-[716px] font-f18'>Limited-time offer—transform your collections process with TREVEX ChatGPT Prompts. Don't miss out!</p>
            <Button onClick={handlePromptStripePayment} classes="w-[308px] h-[96px] bg-primary text-slate rounded-[16px] font-bold flex justify-center items-center text-f30">Get Started Now!</Button>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default GptPrompts